(() => {
  if (window.NanaWorldMap) {
    window.NanaWorldMap.init(document);
    return;
  }
  const init = (scope) => {
    scope.querySelectorAll('[data-nana-world-map]').forEach((component) => {
      if (component.dataset.mapReady) return;
      const root = component.closest('.nana-tasting');
      const source = root && root.querySelector('[data-nt-data]');
      if (!source) return;
      let rows;
      let labels;
      try {
        rows = JSON.parse(source.textContent);
        labels = JSON.parse(component.querySelector('[data-nwm-translations]').textContent);
      } catch (_) {
        return;
      }
      if (!Array.isArray(rows)) return;
      component.dataset.mapReady = 'true';
      const selector = component.querySelector('[data-nwm-select]');
      const canvas = component.querySelector('[data-nwm-canvas]');
      const status = component.querySelector('[data-nwm-status]');
      const hover = component.querySelector('[data-nwm-hover]');
      const countries = new Map();
      const regions = new Map();
      rows.forEach((day) => {
        if (!day.country || !day.region) return;
        if (!countries.has(day.country)) countries.set(day.country, { region: day.region, count: 0 });
        countries.get(day.country).count += 1;
        regions.set(day.region, (regions.get(day.region) || 0) + 1);
      });
      Array.from(countries.keys()).sort((a, b) => a.localeCompare(b)).forEach((country) => {
        const option = document.createElement('option');
        option.value = country;
        option.textContent = country;
        selector.appendChild(option);
      });
      const interpolate = (text, values) => Object.entries(values).reduce((result, [key, value]) => result.replaceAll(`[${key}]`, String(value)), text);
      const buttons = Array.from(component.querySelectorAll('[data-nwm-region-button]'));
      buttons.forEach((button) => {
        const region = button.dataset.nwmRegionButton;
        button.querySelector('[data-nwm-region-count]').textContent = interpolate(labels.day_count, { count: regions.get(region) || 0 });
      });
      let selected = {};
      let svg;
      let zoom = 1;
      let center = [600, 280];
      let loadingPromise;
      const zoomButtons = Array.from(component.querySelectorAll('[data-nwm-zoom]'));
      zoomButtons.forEach((button) => { button.disabled = true; });
      const updateZoom = () => {
        if (!svg) return;
        const width = 1200 / zoom;
        const height = 560 / zoom;
        const x = Math.max(0, Math.min(1200 - width, center[0] - width / 2));
        const y = Math.max(0, Math.min(560 - height, center[1] - height / 2));
        svg.setAttribute('viewBox', [x, y, width, height].join(' '));
        component.classList.toggle('is-zoomed', zoom > 1);
        zoomButtons.forEach((button) => {
          button.disabled = button.dataset.nwmZoom === 'in' ? zoom >= 4 : button.dataset.nwmZoom === 'out' ? zoom <= 1 : false;
        });
      };
      const selectionLabel = () => {
        if (selected.country) return interpolate(labels.country_selected, { country: selected.country, count: countries.get(selected.country)?.count || 0 });
        if (selected.region) return interpolate(labels.region_selected, { region: labels.regions[selected.region] || selected.region, count: regions.get(selected.region) || 0 });
        return labels.all_selected;
      };
      const paint = () => {
        selector.value = selected.country || '';
        status.textContent = selectionLabel();
        const activeRegion = selected.region || countries.get(selected.country)?.region;
        buttons.forEach((button) => { button.setAttribute('aria-pressed', String(button.dataset.nwmRegionButton === activeRegion)); });
        if (!svg) return;
        svg.querySelectorAll('[data-nwm-country]').forEach((piece) => {
          const active = selected.country ? piece.dataset.nwmCountry === selected.country : selected.region ? piece.dataset.nwmRegion === selected.region : false;
          piece.classList.toggle('is-selected', active);
          piece.classList.toggle('is-dim', Boolean(selected.country || selected.region) && !active);
          piece.setAttribute('aria-pressed', String(active));
        });
      };
      const choose = (detail, emit = true) => {
        if (detail.country && !countries.has(detail.country)) return;
        if (detail.region && !regions.has(detail.region)) return;
        selected = detail.country ? { country: detail.country } : detail.region ? { region: detail.region } : {};
        paint();
        if (emit) component.dispatchEvent(new CustomEvent('nana:tasting-filter', { bubbles: true, detail: { ...selected } }));
      };
      const regionHover = (region) => {
        if (!svg) return;
        svg.querySelectorAll('[data-nwm-country]').forEach((piece) => { piece.classList.toggle('is-region-hover', Boolean(region) && piece.dataset.nwmRegion === region); });
      };
      selector.addEventListener('change', () => {
        choose(selector.value ? { country: selector.value } : {});
        if (svg && selector.value) {
          const piece = Array.from(svg.querySelectorAll('[data-nwm-country]')).find((node) => node.dataset.nwmCountry === selector.value);
          if (piece) {
            const box = piece.getBBox();
            center = [box.x + box.width / 2, box.y + box.height / 2];
            updateZoom();
          }
        }
      });
      component.querySelector('[data-nwm-clear]').addEventListener('click', () => {
        choose({});
        zoom = 1;
        center = [600, 280];
        updateZoom();
      });
      root.addEventListener('nana:tasting-reset', () => {
        choose({}, false);
        zoom = 1;
        center = [600, 280];
        updateZoom();
      });
      root.addEventListener('nana:tasting-filter', (event) => {
        if (event.target !== component) choose(event.detail || {}, false);
      });
      buttons.forEach((button) => {
        const region = button.dataset.nwmRegionButton;
        button.addEventListener('click', () => choose(selected.region === region ? {} : { region }));
        button.addEventListener('pointerenter', () => regionHover(region));
        button.addEventListener('pointerleave', () => regionHover(''));
        button.addEventListener('focus', () => regionHover(region));
        button.addEventListener('blur', () => regionHover(''));
      });
      zoomButtons.forEach((button) => button.addEventListener('click', () => {
        if (button.dataset.nwmZoom === 'reset') {
          zoom = 1;
          center = [600, 280];
        } else {
          zoom = Math.max(1, Math.min(4, zoom + (button.dataset.nwmZoom === 'in' ? 1 : -1)));
        }
        updateZoom();
      }));
      const loadMap = () => {
        if (loadingPromise) return loadingPromise;
        loadingPromise = fetch(component.dataset.mapUrl, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error('map_unavailable');
            return response.text();
          })
          .then((text) => {
            const parsed = new DOMParser().parseFromString(text, 'image/svg+xml');
            if (parsed.querySelector('parsererror') || parsed.documentElement.localName !== 'svg') throw new Error('map_unavailable');
            const safeTags = new Set(['svg', 'g', 'defs', 'filter', 'feDropShadow', 'rect', 'path', 'circle', 'title', 'symbol']);
            parsed.querySelectorAll('*').forEach((node) => {
              if (!safeTags.has(node.localName)) {
                node.remove();
                return;
              }
              Array.from(node.attributes).forEach((attribute) => {
                if (attribute.name.startsWith('on') || attribute.name === 'href' || attribute.name === 'xlink:href') node.removeAttribute(attribute.name);
              });
            });
            svg = document.importNode(parsed.documentElement, true);
            const prefix = `nwm-${component.dataset.mapId || 'map'}-${Math.random().toString(36).slice(2, 7)}`;
            svg.querySelectorAll('[id]').forEach((node) => { node.id = `${prefix}-${node.id}`; });
            component.style.setProperty('--nwm-depth', `url(#${prefix}-nwm-wood-depth)`);
            const loading = component.querySelector('[data-nwm-loading]');
            if (loading) loading.remove();
            canvas.appendChild(svg);
            let drag;
            let suppressClick = false;
            svg.addEventListener('pointerdown', (event) => {
              if (zoom <= 1 || event.button !== 0) return;
              drag = { x: event.clientX, y: event.clientY, center: [...center], moved: false, pointer: event.pointerId };
            });
            svg.addEventListener('pointermove', (event) => {
              if (!drag || drag.pointer !== event.pointerId) return;
              const dx = event.clientX - drag.x;
              const dy = event.clientY - drag.y;
              if (Math.abs(dx) + Math.abs(dy) > 8) {
                drag.moved = true;
                svg.setPointerCapture(event.pointerId);
                const rect = svg.getBoundingClientRect();
                center = [drag.center[0] - dx * 1200 / zoom / rect.width, drag.center[1] - dy * 560 / zoom / rect.height];
                updateZoom();
              }
            });
            const finishDrag = (event) => {
              if (!drag || event.pointerId !== drag.pointer) return;
              suppressClick = drag.moved;
              if (svg.hasPointerCapture(event.pointerId)) svg.releasePointerCapture(event.pointerId);
              drag = null;
              setTimeout(() => { suppressClick = false; }, 0);
            };
            svg.addEventListener('pointerup', finishDrag);
            svg.addEventListener('pointercancel', finishDrag);
            svg.querySelectorAll('[data-nwm-country]').forEach((piece) => {
              const country = piece.dataset.nwmCountry;
              if (!countries.has(country)) {
                piece.removeAttribute('tabindex');
                piece.removeAttribute('role');
                return;
              }
              const title = interpolate(labels.country_selected, { country, count: countries.get(country).count });
              piece.setAttribute('aria-label', title);
              if (piece.querySelector('title')) piece.querySelector('title').textContent = title;
              piece.addEventListener('click', () => {
                if (suppressClick) return;
                const box = piece.getBBox();
                center = [box.x + box.width / 2, box.y + box.height / 2];
                choose({ country });
              });
              piece.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  piece.dispatchEvent(new Event('click'));
                }
              });
              piece.addEventListener('pointerenter', () => { hover.textContent = title; });
              piece.addEventListener('pointerleave', () => { hover.textContent = ''; });
              piece.addEventListener('focus', () => {
                hover.textContent = title;
                if (zoom > 1) {
                  const box = piece.getBBox();
                  center = [box.x + box.width / 2, box.y + box.height / 2];
                  updateZoom();
                }
              });
              piece.addEventListener('blur', () => { hover.textContent = ''; });
            });
            component.querySelectorAll('[data-nwm-key-shape]').forEach((key) => {
              const region = key.dataset.nwmKeyShape;
              const slug = region.toLowerCase().replaceAll(' ', '-');
              const symbol = svg.querySelector(`[id="${prefix}-nwm-key-${slug}"]`);
              if (!symbol) return;
              key.setAttribute('viewBox', symbol.getAttribute('viewBox'));
              Array.from(symbol.children).forEach((shape) => key.appendChild(shape.cloneNode(true)));
            });
            updateZoom();
            paint();
          })
          .catch(() => {
            const loading = component.querySelector('[data-nwm-loading]');
            if (loading) loading.textContent = labels.map_unavailable;
          });
        return loadingPromise;
      };
      paint();
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            loadMap();
          }
        }, { rootMargin: '250px' });
        observer.observe(component);
      } else {
        loadMap();
      }
      component.addEventListener('focusin', loadMap, { once: true });
    });
  };
  window.NanaWorldMap = { init };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
